import React from "react";
import ProfilesAndSettings from "views/Config/Profiles/Common";
import AccessProfilesHelpModal from "./Help";
import AccessProfileSettingsHelpModal from "./SettingsHelp";
import { composedAPI } from "./api";
import accessComposition from "./composition";

const ConfigAccessProfiles = ({ ...settings }) => (
  <>
    <ProfilesAndSettings
      {...accessComposition}
      {...composedAPI}
      {...settings}
    />
    <AccessProfilesHelpModal />
    <AccessProfileSettingsHelpModal />
  </>
);

export default ConfigAccessProfiles;
